import parse from 'html-react-parser';
import { PlaybackDetailsResponse } from 'queries/details/usePlaybackDetailsQuery';
import React from 'react';

export const AdditionalText = ({
  playbackData,
}: {
  playbackData: PlaybackDetailsResponse;
}) => {
  const text = playbackData?.landingPageDesign?.additionalText || '';
  const cleanedTextValue = text.replace(/^(&nbsp;|\s)+/, '');
  return <>{parse(cleanedTextValue)}</>;
};
